import {Box, styled} from "@mui/material";

export const LongPageStyled = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    width: '100%',
}))